import { Icon } from '@zoom/components';
import classnames from 'classnames';
import React from 'react';

type Props = {
  className?: string;
  dataTestId?: string;
  kind?: 'warning' | 'error';
} & React.PropsWithChildren;

export const Alert: React.FC<Props> = ({ className, dataTestId, children, kind = 'warning' }) => (
  <div className={classnames('alert', className, { 'alert--error': kind === 'error' })} data-test-id={dataTestId}>
    <Icon kind="warning" size={16} className="alert__icon" data-test-id={dataTestId && `${dataTestId}:alert-icon`} />{' '}
    {children}
  </div>
);
